import { useTypedSelector } from '../app/store';
import { ORGANIZATION_ROLE_TYPES } from '../constants';
import { selectCurrentProfile } from '../features/profile/profileSlice';
import { selectedOrg } from '../features/orgManagement/orgSlice';

type AssignedRole = {
    orgId?: string;
    roleType?: string;
    roleName?: string;
};

export const useIsManager = (assignedRoles?: AssignedRole[]): boolean => {
    const profile = useTypedSelector(selectCurrentProfile);
    const org = useTypedSelector(selectedOrg);
    const roles: AssignedRole[] | undefined = assignedRoles ?? profile?.roles;

    return Boolean(
        org?.id &&
            roles?.some(
                (role) =>
                    role.orgId === org.id &&
                    (role.roleType?.toUpperCase() === ORGANIZATION_ROLE_TYPES.MANAGER ||
                        role.roleName?.toLowerCase() === ORGANIZATION_ROLE_TYPES.MANAGER.toLowerCase())
            )
    );
};

export const useIsViewer = (assignedRoles?: AssignedRole[]): boolean => {
    const profile = useTypedSelector(selectCurrentProfile);
    const org = useTypedSelector(selectedOrg);
    const roles: AssignedRole[] | undefined = assignedRoles ?? profile?.roles;

    return Boolean(
        org?.id &&
            roles?.some(
                (role) =>
                    role.orgId === org.id &&
                    (role.roleType?.toUpperCase() === ORGANIZATION_ROLE_TYPES.VIEWER ||
                        role.roleName?.toLowerCase() === ORGANIZATION_ROLE_TYPES.VIEWER.toLowerCase())
            )
    );
};
